export default defineNuxtPlugin(() => {
    const { $event } = useNuxtApp();

    window.addEventListener("vite:preloadError", () => {
        $event("app:update-available");
    });
});
